module.exports = __webpack_public_path__ + "img/rule-bg-ms.517e36f6.png";